import { HamburgerMenuIcon } from '@radix-ui/react-icons';
import { t } from 'i18next';
import { useContext } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { HeaderLayoutContext } from '../../../app/context/HeaderLayoutContext';
import { useWindowSize } from '../../../app/hooks/useWindowSize';
import { useStore } from '../../../app/store';
import { IconButton } from '../IconButton';
import Logo from '../Logo';

export default function MobileSuperiorHeader() {
  const { toggleSidebar } = useStore(
    useShallow((state) => ({ toggleSidebar: state.sidebar.toggleSidebar })),
  );
  const { isMobile } = useWindowSize();
  const { title } = useContext(HeaderLayoutContext);

  if (!isMobile) return;

  return (
    <header className="text-text-primary absolute flex w-full items-center justify-between gap-3 px-4 pt-4 pb-3">
      <Logo variant="micro" className="h-8 w-8" />

      {title && (
        <h1 className="flex-1 truncate text-center text-base font-semibold">
          {title}
        </h1>
      )}

      <IconButton
        size="lg"
        aria-label={t('sidenavbar.actions.openSidebar', {
          defaultValue: 'Abrir menu',
        })}
        onClick={() => toggleSidebar()}
        className="shrink-0"
      >
        <HamburgerMenuIcon className="size-5" />
      </IconButton>
    </header>
  );
}
